import {createApi, fetchBaseQuery, retry} from '@reduxjs/toolkit/query/react'
import {Auth} from "aws-amplify";
import {setCredentials} from "../config/slices/authSlice";

//export const BASE_URL = 'https://api.fantalab.it/'
export const BASE_URL = 'https://staging.fantalab.it/'
//export const BASE_URL = 'http://Astaplannerapp-env.eba-axwkpjqu.us-east-2.elasticbeanstalk.com/'
//export const BASE_URL = 'http://localhost:5002/'


const baseQueryWithRetry = retry(
   async (args, api, extraOptions) => {
      const result = await fetchBaseQuery({
         baseUrl: BASE_URL,
         prepareHeaders: (headers, {getState}) => {
            const token = getState().auth.token
            if (token) {
               headers.set('authorization', `Bearer ${token}`)
               headers.set('Content-Type', 'application/json')
            }
            return headers
         },
      })(
         args,
         api,
         extraOptions
      )

      if (result.error?.status === 401) {
         try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const currentSession = await Auth.currentSession();
            cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
               const {accessToken} = session;
               import("../config/store").then((o) => {
                  o.store.dispatch(setCredentials({token: accessToken.jwtToken}))
               })
            });
         } catch (e) {
            retry.fail(result.error)
            alert('Qualcosa è andato storto. Ricarica la pagina')
            console.log('Unable to refresh Token', e);
         }
      }
      if(result.error?.status === "FETCH_ERROR"){
         console.log('entra', result.error)
         retry.fail(result.error)
      }
      if (result.error?.status === 502) {
         retry.fail(result.error)
         alert('Qualcosa è andato storto. Ricarica la pagina')
      }


      return result
   },
   {
      maxRetries: 3,
   }
)

/*const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, {getState}) => {
        const token = getState().auth.token
        // If we have a token set in state, let's assume that we should be passing it.
        if (token) {
            headers.set('authorization', `Bearer ${token}`)
            headers.set('Content-Type', 'application/json')
        }

        return headers
    },
})*/

export const api = createApi({
   reducerPath: 'api',
   baseQuery: baseQueryWithRetry,
   tagTypes: ['PlayerStrategy', 'User', 'PlayerOverride', 'Subscription', 'Strategies', 'Subscription', 'Purchases', 'Fantaleagues', 'SeasonsTeams', 'Seasons', 'MembershipUsers', 'MySubscriptions', 'PrivateDocs', 'Creator', 'NextMatches', 'MyAdviceRequests'],
   endpoints: () => ({}),
})

// Export hooks for usage in functional MD, which are
// auto-generated based on the defined endpoints
export const {} = api
